import Text from '@eversports/react-components/primitives/Text'

import { Localized } from '../../localization/react'

const WithdrawalInfo = () => (
  <div>
    <Text size="small" fontWeight="bold" marginBottom="dense">
      <Localized id="right-of-withdrawal-header" />
    </Text>
    <Text size="small">
      <Localized id="right-of-withdrawal-description" />
    </Text>
  </div>
)

export default WithdrawalInfo
